<template>
    <div class="schlist" v-cloak>
        <div v-for="(item,index) in lists" class="list-item" @click="clickItem(item)" >
            <div class="list-time" :class="'list-time'+(index*2%10)" >
                <div class="start-time">
                    <span class="day"
                          v-if="isShowWeekDate || isShowMouthDate || formatDay(item.START_DATE) != searchDate">
                        {{formatDay(item.START_DATE)}}
                    </span>{{formatDate(item.START_DATE) }}
                </div>
                <div class="start-time">
                    <span class="day"
                          v-if="isShowWeekDate || isShowMouthDate || formatDay(item.END_DATE) != searchDate">
                        {{formatDay(item.END_DATE)}}
                    </span>{{formatDate(item.END_DATE)}}
                </div>
            </div>
            <div class="list-info">
                <div class="list-type-info">
                    <span class="list-type" :class="showClass(item)">{{ item.TYPE }}</span>
                    <span v-if="caleIsCan(item)">{{ item.FLOW_STATUS }}</span><!-- STATUS 0是有效 1是无效-->
                </div>
                <div class="subject-box" v-if="item.TYPE=='日程'">
                    <div class="note">{{ item.NOTE }}</div>
                </div>
                <div class="ayyle-name" v-if="item.TYPE=='FAE' && isSchedule">
                    <span class="fae-name">预约FAE：{{ item.FAE_NAME }}</span>
                    <span class="fae-position">({{ item.FAE_POSITION_NAME }})</span>
                    <!--                    <span>({{ item.DATA_STATUS }})</span>-->
                </div>
                <div class="ayyle-name" v-if="item.TYPE=='FAE' && !isSchedule">
                    <span class="fae-name">申请人：{{ item.APPLY_NAME }}</span>
                </div>
                <div class="list-remark" v-if="caleIsCan(item)">{{ item.NOTE || item.REMARK }}</div>
            </div>

            <div class="list-btn" v-if="showOutBtn(item)" @click.stop="addOut(item)">
                <i class="iconfont iconziyuan210" ></i>
            </div>
            <div class="list-btn" v-if="showBtn(item)" @click.stop="cheakFAE(item)">
                <i class="iconfont iconwangdiandaka" ></i>
            </div>
            <div class="list-btn" v-if="showEditBtn(item)" @click.stop="editItem(item)">
                <van-icon name="edit" />
            </div>
            <div class="list-btn" v-if="showDeleteBtn(item)" @click.stop="deleteItem(item)">
                <van-icon name="delete" />
            </div>

        </div>
        <locate v-if="showLocate" :id="entityId" @confirm="onlocate" @cancel="onCancelLocate"></locate>
        <Loading v-if="loading"></Loading>
    </div>
</template>

<script>
    import common from '@/api/common';
    import api from '@/api/fae';

    import locate from './locate'

    import Loading from '@/components/Loading';

    export default {
        name: "schLists",
        props: {
            lists: Array,
            isSchedule: {
                type: Number,
                default: 0,
            },
            isShowWeekDate: {
                type: Boolean,
                default: false,
            },
            isShowMouthDate: {
                type: Boolean,
                default: false,
            },
            searchDate: String
        },
        components: {locate, Loading},
        data() {
            return {
                isShowBtn: false, // 是否可以操作
                isChanging: false, // 解决闪现
                showLocate: false,  // 是否显示定位

                entityId: '', // 当前操作的记录ID
                processInstanceId: '', // 当前操作的流程ID

                bosArrName: [],    // 特殊权限的人群，从快码配置并关联的TEMP_CUSTOMER的字段
                isBoss: false, // 当前用户是否是特殊权限的人群
                subArrIds: [],     // 下属
                bosArrIds: [],     // 上级
                loading: false, // 加载中
                source:''

            }
        },
        mounted() {
            try {
                this.bosArrName = JSON.parse(localStorage.getItem('BOSS_NAME'));
                let userName = JSON.parse(localStorage.getItem('LS_ADMIN')).USER_ACCOUNT; // 当前用户 英文名
                let dutyName = JSON.parse(localStorage.getItem('LS_ADMIN')).DUTY_NAME; // 当前用户 英文名
                this.isBoss = this.bosArrName.includes(userName) || this.bosArrName.includes(dutyName);

                this.subArrIds = JSON.parse(localStorage.getItem('USER_Subordinate_FORMAT'));
                this.bosArrIds = JSON.parse(localStorage.getItem('USER_BOSS_FORMAT'));
            } catch (e) {

            }

            if (this.CoreNew.WEB_URL_SOURCE) {
                this.source = this.CoreNew.WEB_URL_SOURCE
            }

        },

        methods: {
            /**
             *  显示规则如下：
             *  1.只有FAE类型
             *  2.当前用户是 被预约的FAE
             *  3.当前用户是 申请人
             *  4.当前用户是 被预约的FAE 的领导
             *  5.当前用户是 申请人 的领导
             *  6.当前用户是快码配置里配置的数据 用户名
             *   isFAEBoss: false, // 当前用户是否是FAE的BOSS
             *   isApplyBoss: false, // 当前用户是否是申请人的BOSS
             * */

            // 判断是否有权限
            caleIsCan(item) {
                let ADMIN = JSON.parse(localStorage.getItem('LS_ADMIN'))
                let userId = ADMIN.USER_ID;
                let userName = ADMIN.USER_ACCOUNT;
                let applyId = Number(item.APPLY_ID); // 申请人
                let faeId = Number(item.FAE_EMP);    // FAE
                let type = item.TYPE;

                // this.isBoss = this.bosArrName.includes(userName) || this.bosArrName.includes(dutyName);
                if (this.isBoss) {
                    return true
                }

                if (type == 'FAE') {
                    if (this.isBoss || userId == applyId || userId == faeId || this.subArrIds.includes(applyId) || this.subArrIds.includes(faeId)) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    if (this.isBoss || userId == applyId || this.subArrIds.includes(applyId)) {
                        return true
                    } else {
                        return false
                    }
                }
            },
            /**
             * 日程只能在日程里查看
             * */
            showItem(item){
                let type = item.TYPE;
                if (type == '日程') {
                    if (this.isSchedule) {
                        return true
                    } else {
                        return false
                    }
                }else{
                    return true
                }
            },

            clickItem(item) {
                let type = item.TYPE;
                if (type == 'FAE') {
                    this.showFAE(item)
                } else if (type == '日程') {
                    this.showSchedule(item)
                } else if (type == '外出' || type == '出差' || type == '请假') {
                    this.showHrDetail(item)
                }
            },


            showBtn(item) {
                let userid = JSON.parse(localStorage.getItem('LS_ADMIN_USER_ID'));
                let id = item.APPLY_ID; // 申请人
                let faeId = item.FAE_EMP; // FAE
                let startDate = this.Common.toTimeDate(item.START_DATE);  // 预约时间
                let currentDate = this.Common.toTimeDate(this.Common.timestampToTime(new Date()));
                // 打卡人是 FAE  if (userid == id || userid == faeId)
                // 销售打卡会覆盖打卡记录 取消销售打卡
                if (userid == faeId && startDate == currentDate && item.FLOW_STATUS == 'FAE处理完成:审批中') {
                    return true
                } else {
                    return false
                }
            },
            showOutBtn(item) {
                let userid = JSON.parse(localStorage.getItem('LS_ADMIN_USER_ID'));
                let id = item.APPLY_ID; // 申请人
                let faeId = item.FAE_EMP; // FAE
                let type = item.TYPE;

                if (type == 'FAE') {
                    if (userid == id || userid == faeId) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            showDeleteBtn(item) {
                let userid = JSON.parse(localStorage.getItem('LS_ADMIN_USER_ID'));
                let id = item.APPLY_ID;
                let faeId = item.FAE_EMP; // FAE
                let type = item.TYPE;

                // item.FLOW_STATUS == '审批通过,流程结束' || item.FLOW_STATUS == '任务拒绝,流程结束'

                //id == userid && item.FLOW_STATUS == 'FAE预约审批,审批中'
                if (type == 'FAE') {
                    if (!item.PROCESS_INSTANCE_ID) {
                        return false
                    }

                    if ((item.FLOW_STATUS == 'FAE预约审批,审批中' || item.FLOW_STATUS == 'FAE处理完成:审批中') && (id == userid  || userid == faeId )) {
                        return true
                    } else {
                        return false
                    }
                } else if (type == '日程') {

                    if (id == userid ) {
                        return true
                    } else {
                        return false
                    }

                }
            },
            showEditBtn(item) {
                let type = item.TYPE;
                if (type == '日程') {
                    return true
                } else {
                    return false
                }
            },
            formatDate(date) {
                return this.Common.timesToTime(date)
            },
            formatDay(date) {
                return this.Common.timesToDay(date)
            },
            //:class="item.TYPE=='请假' ?'list-qj':''"
            showClass(item) {
                if (item.TYPE == '外出') {
                    return 'out_list'
                } else if (item.TYPE == '出差') {
                    return 'trip_list'
                } else if (item.TYPE == '请假') {
                    return 'vacate_list'
                } else if (item.TYPE == '日程') {
                    return 'sche_list'
                }else {
                    return ''
                }
            },

            /**查看 HR 记录相关详情
             外出 ehrdetailok?page=apply&types=wc&number=WWD-20200617-00125533
             请假 ehrdetailok?page=apply&types=qj&number=QJD-20200909-000017
             出差 是财务的 不能跳转
             https://fssc.cecport.com:8443/travel/travelApply
             ?id=8a81e41e6f9d3f17016fa7fe2f1b583f&isMobile=1&backUrl=https://events.cecport.com/apply?sys=fssc
             **/
            showHrDetail(item) {
                let types = '', number = '';
                let iscan = this.caleIsCan(item);

                if (item.TYPE == '外出') {
                    types = 'wc';
                    number = item.APPLY_NO
                } else if (item.TYPE == '出差') {
                    this.$toast("请去财务系统查看！");
                    return
                } else if (item.TYPE == '请假') {
                    types = 'qj';
                    number = item.APPLY_NO
                } else {
                    this.$toast("您的权限貌似不够哦！");
                }

                if (iscan) {
                    this.$router.push({
                        path: '/ehrdetailok',
                        query: {
                            page: 'apply',
                            types: types,
                            number: number,
                            source: this.source
                        }
                    })
                } else {
                    this.$toast("您的权限貌似不够哦！");
                }
            },


            deleteItem(item) {
                if (item.TYPE == 'FAE') {
                    this.deleteFAE(item)
                } else if (item.TYPE == '日程') {
                    this.deleteSchedule(item.ID)
                }
            },

            editItem(item) {
                if (item.TYPE == 'FAE') {
                    this.editFAE(item.ID)
                } else if (item.TYPE == '日程') {
                    this.editSchedule(item)
                }
            },

            addOut(item) {
                this.$router.push({
                    path: '/addout',
                    query: {
                        entityId: item.id,
                        sDate: item.START_DATE,
                        eDate: item.END_DATE,
                        remark: item.REMARK,
                        // source1: 'fae',
                        source: this.source
                    }
                })
            },

            showFAE(item) {
                let iscan = this.caleIsCan(item);
                if (iscan) {
                    this.$router.push({
                        path: '/fae/edit',
                        query: {
                            entityId: item.ID,
                            type: 'see',
                            isSchedule: this.isSchedule,
                            source: this.source
                        }
                    })
                } else {
                    this.$toast("您的权限貌似不够哦！");
                }
            },
            showSchedule(item) {
                let iscan = this.caleIsCan(item);
                if (iscan) {
                    this.$router.push({
                        path: '/schedule/addSchedule',
                        query: {
                            entityId: item.ID,
                            faeId:item.FAE_EMP,
                            type: 'see',
                            isSchedule: this.isSchedule,
                            source: this.source
                        }
                    })
                } else {
                    this.$toast("您的权限貌似不够哦！");
                }
            },

            deleteSchedule(id) {
                this.$dialog.confirm({
                    title: '确定要删除日程吗？'
                }).then(() => {
                    common.detComData(this.CoreNew.SYSTABLE.SCHEDULE, id).then(res => {
                        if (res && res.flag) {
                            this.$toast("删除成功！");
                            this.$emit('updata');
                        } else {
                            this.$toast("网络异常，请稍后再试！");
                        }
                    })
                }).catch(() => {
                    // on cancel
                });
            },
            editSchedule(item) {
                this.$router.push({
                    path: '/schedule/addSchedule',
                    query: {
                        entityId: item.ID,
                        faeId:item.FAE_EMP,
                        type: 'edit',
                        isSchedule: this.isSchedule,
                        source: this.source
                    }
                })
            },
            editFAE(id) {
                // this.$emit('editData',id);
                this.$router.push({
                    path: '/fae/edit',
                    query: {
                        entityId: id,
                        type: 'edit',
                        isSchedule: this.isSchedule,
                        source: this.source
                    }
                })
            },
            /*流程删除*/
            deleteFAE(item) {
                if (!item.PROCESS_INSTANCE_ID) {
                    this.$toast("流程id为空，请联系系统管理员！");
                    return
                }

                this.$dialog.confirm({
                    title: '确定要取消预约吗？'
                }).then(() => {
                    /**
                     * userID FAE用户ID 303
                     * processInstanceId 流程实例ID
                     * refuseReason 拒绝理由
                     */

                    let params = {
                        userID: JSON.parse(localStorage.getItem('LS_ADMIN_USER_ID')),
                        processInstanceId: item.PROCESS_INSTANCE_ID,
                        refuseReason: '',
                    }
                    this.loading = true;
                    api.refuseTaskByProcessInstanceId(params).then(res => {
                        this.loading = false;
                        if (res && res.flag) {
                            this.$toast("取消预约，流程关闭！");
                            this.$router.go(0);
                        } else {
                            this.$toast("网络异常，请稍后再试！");
                        }
                    })
                    // common.detComData(this.CoreNew.SYSTABLE.FAE, id).then(res => {
                    //     if (res && res.flag) {
                    //         this.$toast("删除成功！");
                    //         // this.$router.go(0);
                    //         this.$emit('updata');
                    //     } else {
                    //         this.$toast("网络异常，请稍后再试！");
                    //     }
                    // })
                })
            },
            /* 通用删除*/
            /*deleteFAE(id) {
                this.$dialog.confirm({
                    title: '确定要取消预约吗？'
                }).then(() => {
                    common.detComData(this.CoreNew.SYSTABLE.FAE, id).then(res => {
                        if (res && res.flag) {
                            this.$toast("删除成功！");
                            // this.$router.go(0);
                            this.$emit('updata');
                        } else {
                            this.$toast("网络异常，请稍后再试！");
                        }
                    })
                }).catch(() => {
                    // on cancel
                });
            },*/
            cheakFAE(item) {
                this.showLocate = true;
                this.entityId = item.ID;
                this.processInstanceId = item.PROCESS_INSTANCE_ID
            },
            onCancelLocate() {
                this.showLocate = false
            },
            // 定位打卡
            onlocate(data) {
                this.addComLocate(data)
            },

            addComLocate(data) {
                let ADMIN = JSON.parse(localStorage.getItem('LS_ADMIN'));
                let address = data.address,
                    latitude = data.latitude,
                    longitude = data.longitude,
                    userID = ADMIN.USER_ID.toString(),
                    deptID = ADMIN.USER_DEPARTMENT_ID.toString(),
                    faeID = this.entityId.toString(),
                    currentDate = this.Common.timestampToTime(new Date());

                let params = {
                    ADDRESS: address,
                    DELETE_STATUS: null,
                    DEPT_ID: deptID,
                    EMP_CODE: null,
                    EMP_ID: userID,
                    FAE_SUBSCRIBE_ID: faeID,
                    LATITUDE: latitude,  //经度
                    LONGITUDE: longitude, //纬度
                    PROCESS_DEFINITION_ID: null,
                    PUNCHT_TIME: currentDate
                };
                common.addComData(this.CoreNew.SYSTABLE.FAE_CLOCKING, params).then(res => {
                    if (res && res.flag) {
                        this.$toast("定位打卡成功！");
                        this.showLocate = false;
                        this.agreeTaskByProcess();
                    } else {
                        this.$toast("网络异常，请稍后再试！");
                    }
                })
            },
            agreeTaskByProcess() {
                let params = {
                    userID: JSON.parse(localStorage.getItem('LS_ADMIN_USER_ID')),
                    processInstanceId: this.processInstanceId,
                    agreeReason: '移动端定位打卡确认',
                }
                this.loading = true;
                api.agreeTaskByProcessInstanceId(params).then(res => {
                    this.loading = false;
                    if (res && res.flag) {
                        this.$toast("FAE 流程确认完成！");
                        this.$emit('updata');

                    } else {
                        this.$toast("网络异常，请稍后再试！");
                    }
                })

            }


        }
    }
</script>

<style scoped lang="less">
    // @import "../../../assets/css/base.less";

    [v-cloak] {
        display: none !important;
    }

    .list-item {
        display: flex;
        align-content: center;
        justify-content: center;
        position: relative;

        .list-time {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            font-size: 10px;
            border-right: 2px solid #eee;
            padding: 10px;
            line-height: 2.4;
            width: 30px;

            .start-time {
                position: relative;

                .day {
                    position: absolute;
                    top: -10px;
                    left: -10px;
                    transform: scale(0.75);
                    color: @yellow;
                }


                .show {
                    display: inline-block;
                }
            }
        }

        .list-time0 {
            border-color: #00a8ff;
        }

        .list-time2 {
            border-color: #9c88ff;
        }

        .list-time4 {
            border-color: #fbc531;
        }

        .list-time6 {
            border-color: #4cd137;
        }

        .list-time8 {
            border-color: #e84118;
        }


        .list-info {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            padding: 10px;
            font-size: 12px;

            .list-type-info {
                .list-type {
                    background: #2196f3;
                    color: #fff;
                    height: 20px;
                    padding: 0 10px 0 5px;
                    line-height: 20px;
                    border-radius: 0 10px 10px 0;
                    transform: scale(0.8);
                    margin-right: 5px;
                }

                .out_list {
                    background: rgb(76, 175, 80)
                }

                .trip_list {
                    background: rgb(255, 193, 7)
                }

                .vacate_list {
                    background: rgb(96, 125, 139)
                }

                .sche_list{
                    background: rgb(103, 58, 183)
                }
            }

            .subject-box {
                margin-top: 4px;

                .subject {
                    color: @font3;
                    font-size: 14px;
                }

                .note {
                    color: @font6;
                }
            }

            .ayyle-name {
                margin-top: 4px;
                color: @font9;

                .fae-position {
                    margin-left: 4px;
                }
            }

            .list-remark {
                white-space: normal;
                word-break: break-all;
                margin-top: 8px;
                max-height: 50px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
            }
        }

        .list-btn {
            font-size: 20px;
            color: #2196f3;
            width: 40px;
            display: flex;
            justify-content: center;
            align-items: center;

            .van-icon {
                height: 100%;
                width: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .iconziyuan210 {
                font-size: 20px;
            }

            .iconwangdiandaka {
                font-size: 22px;
            }
        }

        .list-btn.hide {
            display: none;
        }
    }

    .list-item::after {
        position: absolute;
        left: 0;
        bottom: -1px;
        content: '';
        background: #ddd;
        width: 100%;
        height: 1px;
    }
</style>